function refIsCallback(ref) {
  return typeof ref === 'function';
}

export { refIsCallback as default };
//# sourceMappingURL=refIsCallback.js.map
